import { isBdPeriod, type BdPeriod } from "@shared/bdPeriod";

/** The page's state lives in the URL so a view survives reload and can be linked. */
export function readBdParams(search: string): { period: BdPeriod; who: string } {
  const p = new URLSearchParams(search.startsWith("?") ? search.slice(1) : search);
  const period = p.get("period");
  return { period: isBdPeriod(period) ? period : "month", who: p.get("who") || "all" };
}

export function bdHref(period: BdPeriod, who: string): string {
  const p = new URLSearchParams();
  if (who !== "all") p.set("who", who);
  if (period !== "month") p.set("period", period);
  const q = p.toString();
  return q ? `/coi?${q}` : "/coi";
}

/** A stale ?who= (deactivated user, old bookmark) is a 400. Any other failure keeps the view and offers Retry. */
export function staleWho(who: string, error: unknown): boolean {
  return who !== "all" && (error as { status?: number } | null)?.status === 400;
}
